export default __webpack_public_path__ + "static/media/ren.0f87b955.svg";